export enum MissingTransactionInfoType {
  None = 'None',
  Generic = 'Generic', 
  CountryTo = 'CountryTo',
  CurrencyTo = 'CurrencyTo',
  AmountFrom = 'AmountFrom',
  PaymentMethod = 'PaymentMethod',
  DeliveryMethod = 'DeliveryMethod',
  RecipientInfo = 'RecipientInfo',
  BankInfo = 'BankInfo',
  AgentToInfo = 'AgentToInfo',
  AdditionalFields = 'AdditionalFields',
  IdDocumentAdditionalFields = 'IdDocumentAdditionalFields',
  PaymentAccount = 'PaymentAccount',
  RequiresIdentityVerification = 'RequiresIdentityVerification',
  HigherLimitIdentityVerificationRequired = 'HigherLimitIdentityVerificationRequired',
  RequiresPayerAuthenticationCheck = 'RequiresPayerAuthenticationCheck',
  InvalidPromoCode = 'InvalidPromoCode',
  IdExpired = 'IdExpired',
  TransactionNotAllowedForMissingID = 'TransactionNotAllowedForMissingID',
  RequiresAdditionalDocuments = 'RequiresAdditionalDocuments',
  CardNotEnrolledInPayerAuthentication = 'CardNotEnrolledInPayerAuthentication',
  CustomerNeedToVerifyIdentityThroughVeriffOnOnfido="CustomerNeedToVerifyIdentityThroughVeriffOnOnfido",
  VirtualPaymentAccountInfo = 'VirtualPaymentAccountInfo'
}


// WEBPACK FOOTER //
// ./src/model/types/missing-transaction-info-type.ts